import { MedicalEventDocumentType } from '../model/MedicalEvent'

export const getDocOrFileAnchor = (id: number, type: MedicalEventDocumentType) => {
  if (type === MedicalEventDocumentType.FW_DOCUMENT) return `#document=${id}`
  if (type === MedicalEventDocumentType.FILE) return `#file=${id}`
}
